var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-big"},[_c('TextElement',{attrs:{"overline":_vm.data.overline,"headline":_vm.data.headline,"text":_vm.data.text}}),_c('AdviceList',{attrs:{"items":_vm.listItems},on:{"item":_vm.onItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }